const partition = <Item, ItemPass extends Item = Item, ItemFail extends Item = Item>(
    data: Item[] | undefined,
    filter: (item: Item) => boolean,
): [ItemPass[] | undefined, ItemFail[] | undefined] => {
    return (
        data?.reduce<[ItemPass[], ItemFail[]]>(
            (acc, item) => {
                if (filter(item)) acc[0].push(item as ItemPass);
                else acc[1].push(item as ItemFail);
                return acc;
            },
            [[], []],
        ) ?? [undefined, undefined]
    );
};

export { partition };
